import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { TaskStatus } from '../../tasks/TaskStatus';

@Component({
  selector: 'app-search-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class SearchItemComponent implements OnInit {

  @Output() removeRule = new EventEmitter<any>();

  @Input() rules: {
    field: string,
    opr: string,
    value: any,
    type: string
  };

  @Input() fields: any[];
  loaded = false;

  selected_type = "boolean";
  multi_select_values = [];
  options: any[];





  constructor(public globalService: GlobalService) {
   
  }



  ngOnInit() {
    console.log("Rules: ", JSON.stringify(this.rules));
    this.GetType();
    this.loaded = true;
  }

  async GetType() {
    console.log(this.rules.field);
    console.log("VALUE:", this.rules.value);
    let index = this.fields.findIndex(item => item.name === this.rules.field);
    this.selected_type = this.fields[index].type;
    this.options = this.fields[index].options;
    this.rules.type = this.selected_type;


    //Setup the default values for everything
    if (this.selected_type == "boolean") {
      if (typeof this.rules.value !== "boolean") this.rules.value = false;
      this.rules.opr = 'equals';
    }
    else if (this.selected_type == "string") {
      if (typeof this.rules.value !== "string") this.rules.value = '';
      this.rules.opr = 'equals';
    }
    else if (this.selected_type == "category") {
      if (!Array.isArray(this.rules.value)) this.rules.value = [];
      this.rules.opr = 'contains-any';
    } else if (this.selected_type == "number") {
      if (typeof this.rules.value !== "number") this.rules.value = 0;
      this.rules.opr = 'equals';
    } else if (this.selected_type == "date") {
      // You may want a more robust date check, but for now:
      if (typeof this.rules.value !== "string") this.rules.value = this.globalService.ReturnFormattedDate(new Date().toISOString());
      this.rules.opr = 'equals';
    }

    //this.globalService.GetArrayIndex(this.fields,this.rules.field);
  }

  async Remove() {
    this.removeRule.emit();
  }

}
